const initialState = {
  name: '',
  email: '',
  profilePicture: '',
  centers: [],
  centerId: 0,
  flags: { }
};

export function identity (state = initialState, action) {
  switch (action.type) {
    case 'persist/REHYDRATE':
      const payload = action.payload;

      if (payload && payload.identity) {
        return {
          ...state,
          centerId: payload.identity.centerId
        };
      }
      return { ...state };
    case 'FETCH_PROFILE':
      return {
        ...state,
        profilePicture: ''
      };
    case 'FETCH_PROFILE_SUCCESS':
      return {
        ...state,
        legacyUserId: action.userId,
        profilePicture: action.profilePicture,
        name: action.name,
        email: action.email,
        centers: action.centers,
        centerId: parseInt(state.centerId ? state.centerId : action.centers[0].id, 10)
      };
    case 'SWITCH_ACTIVE_CENTER':
      return {
        ...state,
        centerId: action.centerId
      };
    case 'SET_FEATURE_FLAG':
      return {
        ...state,
        flags: {
          ...state.flags,
          ...action.flag
        }
      };
    default:
      return state;
  }
}
